export default __webpack_public_path__ + "static/media/PAFI_Announcement of GMS 2022.d95abcc0.pdf";